import { FormControlLabel, FormHelperText, Checkbox, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

type CheckboxProps = {
    onChange?: any
    name?: string
    label?: string
    value?: string
    checked?: boolean
    disabled?: boolean
    required?: boolean
    labelPlacement?: 'top' | 'bottom' | 'start' | 'end'
    color?: 'primary' | 'secondary'
    overrideClass?: {}
    classNameLabel?: string
    helperText?: string
    input?: any
    meta?: any
}

const CheckboxControl = (props: CheckboxProps) => {
    const {
        name,
        label,
        value,
        checked,
        disabled,
        required,
        onChange,
        labelPlacement = 'end',
        color = 'primary',
        overrideClass,
        classNameLabel,
        helperText,
        meta,
    } = props

    const { t } = useTranslation()

    return (
        <div>
            <FormControlLabel
                control={
                    <Checkbox
                        name={name}
                        checked={checked}
                        value={value}
                        onChange={onChange}
                        classes={overrideClass}
                        color={color}
                    />
                }
                label={<Typography className={classNameLabel}>{label}</Typography>}
                labelPlacement={labelPlacement}
                disabled={disabled}
            />
            <FormHelperText>
                <label style={{ color: '#d32f2f' }}>
                    {!disabled ? (required ? t('LABEL.SELECT_REQUIRED') : '') : ''}
                </label>
            </FormHelperText>
        </div>
    )
}

export default CheckboxControl
